import { render, staticRenderFns } from "./Yleisohjelma.vue?vue&type=template&id=2db71a45&scoped=true"
var script = {}
import style0 from "./Yleisohjelma.vue?vue&type=style&index=0&id=2db71a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db71a45",
  null
  
)

export default component.exports